// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "02f8947814bf";
export const BUILD_VERSION_NUMBER = 72;
